import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-about-dialog',
  templateUrl: './about-dialog.component.html',
  styleUrls: ['./about-dialog.component.css'],
  standalone: false,
})
export class AboutDialogComponent implements OnInit {
  private http = inject(HttpClient);

  clientVersion: string;
  licenses: Observable<string>;

  ngOnInit(): void {
    this.clientVersion = '32.0.0-dev'; // TODO: Automatically update this? Maybe use a tag and overwrite it in CI?
    this.licenses = this.http.get('3rdpartylicenses.txt', { responseType: 'text' });
  }
}
